import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { BnNgIdleService } from 'bn-ng-idle';
import { LoginDataService } from './services/dhukan/login-data.service';
import { AppRoutingModule } from "./app-routing.module";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  // imports: [AppRoutingModule]
})
export class AppComponent implements OnInit,AfterViewChecked  {
  
 
  title = 'RBOOK';

  islogin:boolean=false;

  constructor(private appService: LoginDataService, private bnIdle: BnNgIdleService) {
    // this.bnIdle.startWatching(300).subscribe((res) => {
    //   if (res) {
    //     sessionStorage.removeItem("rbookadtoken");
        
    //     this.appService.fnCheckLogin();
    //   }
    // })

    
  }

  ngOnInit() { 
    
   
  }

  ngAfterViewChecked(): void {

    setTimeout(() =>  this.islogin=this.appService.islogin );
     
  }

}
